// extracted by mini-css-extract-plugin
module.exports = {"flex":"Certificates_flex__uvN9r","paragraph":"Certificates_paragraph__H3KYk"};